//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class PageJS {
    constructor(common) {
        this.common = common;
        this.BREAK_SP = 767;
    }

    mq(type = "sp") {
        if (type === "sp") return `(max-width: ${this.BREAK_SP}px)`;
        if (type === "pc") return `(min-width: ${this.BREAK_SP + 1}px)`;
        return type;
    }

    init() {
        this._secGallery();

        this.common.init();//common.jsはここでinitさせる
    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    _secGallery_BK() {
        const modal = document.getElementById("galleryModal");
        const modalBg = modal?.querySelector(".gallery_modal_bg");
        const modalClose = modal?.querySelector(".gallery_modal_close");
        const modalPrev = modal?.querySelector(".gallery_modal_prev");
        const modalNext = modal?.querySelector(".gallery_modal_next");
        const modalImg = document.getElementById("galleryModalImg");
        const modalMedia = document.getElementById("galleryModalMedia");

        if (!modal || !modalImg || !modalMedia) return;

        let galleryMap = {};
        let currentCategory = "";
        let currentIndex = 0;

        const buildGalleryMap = () => {
            galleryMap = {};

            const buttons = document.querySelectorAll(".gallery_open");

            buttons.forEach((btn) => {
                const category = btn.dataset.category;
                const index = Number(btn.dataset.index);

                if (!galleryMap[category]) {
                    galleryMap[category] = [];
                }

                galleryMap[category][index] = {
                    src: btn.dataset.src || "",
                    alt: btn.dataset.alt || "",
                    type: btn.dataset.type || "landscape",
                };
            });

            Object.keys(galleryMap).forEach((category) => {
                galleryMap[category] = galleryMap[category].filter(Boolean);
            });
        };

        const updateModal = () => {
            const items = galleryMap[currentCategory];
            if (!items || !items.length || !items[currentIndex]) return;

            const item = items[currentIndex];

            modalImg.src = item.src;
            modalImg.alt = item.alt;

            modalMedia.classList.remove("is-landscape", "is-portrait");
            modalMedia.classList.add(item.type === "portrait" ? "is-portrait" : "is-landscape");

            if (modalPrev) {
                if (currentIndex === 0) {
                    modalPrev.classList.add("is-disabled");
                } else {
                    modalPrev.classList.remove("is-disabled");
                }
            }

            if (modalNext) {
                if (currentIndex === items.length - 1) {
                    modalNext.classList.add("is-disabled");
                } else {
                    modalNext.classList.remove("is-disabled");
                }
            }
        };

        const openModal = (category, index) => {
            const items = galleryMap[category];
            if (!items || !items.length) return;

            currentCategory = category;
            currentIndex = index;

            updateModal();

            modal.classList.add("is-open");
            modal.setAttribute("aria-hidden", "false");
            document.body.classList.add("is-modal-open");
        };

        const closeModal = () => {
            modal.classList.remove("is-open");
            modal.setAttribute("aria-hidden", "true");
            document.body.classList.remove("is-modal-open");
        };

        const showPrev = () => {
            const items = galleryMap[currentCategory];
            if (!items || !items.length) return;

            currentIndex = (currentIndex - 1 + items.length) % items.length;
            updateModal();
        };

        const showNext = () => {
            const items = galleryMap[currentCategory];
            if (!items || !items.length) return;

            currentIndex = (currentIndex + 1) % items.length;
            updateModal();
        };

        buildGalleryMap();

        document.addEventListener("click", (e) => {
            const btn = e.target.closest(".gallery_open");
            if (!btn) return;

            const category = btn.dataset.category;
            const index = Number(btn.dataset.index);

            openModal(category, index);
        });

        modalBg?.addEventListener("click", closeModal);
        modalClose?.addEventListener("click", closeModal);
        modalPrev?.addEventListener("click", showPrev);
        modalNext?.addEventListener("click", showNext);

        document.addEventListener("keydown", (e) => {
            if (!modal.classList.contains("is-open")) return;

            if (e.key === "Escape") {
                closeModal();
            } else if (e.key === "ArrowLeft") {
                showPrev();
            } else if (e.key === "ArrowRight") {
                showNext();
            }
        });

        window.addEventListener("resize", () => {
            if (!modal.classList.contains("is-open")) return;
            updateModal();
        });
    }
    _secGallery() {
        const modal = document.getElementById("galleryModal");
        const modalBg = modal?.querySelector(".gallery_modal_bg");
        const modalClose = modal?.querySelector(".gallery_modal_close");
        const modalPrev = modal?.querySelector(".gallery_modal_prev");
        const modalNext = modal?.querySelector(".gallery_modal_next");
        const modalImg = document.getElementById("galleryModalImg");
        const modalMedia = document.getElementById("galleryModalMedia");
        const modalTitleBig = document.getElementById("galleryModalTitleBig");
        const modalTitleSmall = document.getElementById("galleryModalTitleSmall");
        const modalCaption = document.getElementById("galleryModalCaption");

        if (!modal || !modalImg || !modalMedia) return;

        let galleryMap = {};
        let currentCategory = "";
        let currentIndex = 0;

        const buildGalleryMap = () => {
            galleryMap = {};

            const buttons = document.querySelectorAll(".gallery_open");

            buttons.forEach((btn) => {
                const category = btn.dataset.category;
                const index = Number(btn.dataset.index);

                if (!galleryMap[category]) {
                    galleryMap[category] = [];
                }

                galleryMap[category][index] = {
                    src: btn.dataset.src || "",
                    alt: btn.dataset.alt || "",
                    type: btn.dataset.type || "landscape",
                    titleBig: btn.dataset.titleBig || "",
                    titleSmall: btn.dataset.titleSmall || "",
                    caption: btn.dataset.caption || "",
                };
            });

            Object.keys(galleryMap).forEach((category) => {
                galleryMap[category] = galleryMap[category].filter(Boolean);
            });
        };

        const updateModal = () => {
            const items = galleryMap[currentCategory];
            if (!items || !items.length || !items[currentIndex]) return;

            const item = items[currentIndex];

            modalImg.src = item.src;
            modalImg.alt = item.alt;

            if (modalTitleBig) modalTitleBig.textContent = item.titleBig || "";
            if (modalTitleSmall) modalTitleSmall.textContent = item.titleSmall || "";
            if (modalCaption) modalCaption.textContent = item.caption || "";

            modalMedia.classList.remove("is-landscape", "is-portrait");
            modalMedia.classList.add(item.type === "portrait" ? "is-portrait" : "is-landscape");

            if (modalPrev) {
                if (currentIndex === 0) {
                    modalPrev.classList.add("is-disabled");
                } else {
                    modalPrev.classList.remove("is-disabled");
                }
            }

            if (modalNext) {
                if (currentIndex === items.length - 1) {
                    modalNext.classList.add("is-disabled");
                } else {
                    modalNext.classList.remove("is-disabled");
                }
            }
        };

        const openModal = (category, index) => {
            const items = galleryMap[category];
            if (!items || !items.length || !items[index]) return;

            currentCategory = category;
            currentIndex = index;

            updateModal();

            modal.classList.add("is-open");
            modal.setAttribute("aria-hidden", "false");
            document.body.classList.add("is-modal-open");
        };

        const closeModal = () => {
            modal.classList.remove("is-open");
            modal.setAttribute("aria-hidden", "true");
            document.body.classList.remove("is-modal-open");
        };

        const showPrev = () => {
            const items = galleryMap[currentCategory];
            if (!items || !items.length) return;
            if (currentIndex === 0) return;

            currentIndex--;
            updateModal();
        };

        const showNext = () => {
            const items = galleryMap[currentCategory];
            if (!items || !items.length) return;
            if (currentIndex === items.length - 1) return;

            currentIndex++;
            updateModal();
        };

        buildGalleryMap();

        document.addEventListener("click", (e) => {
            const btn = e.target.closest(".gallery_open");
            if (!btn) return;

            const category = btn.dataset.category;
            const index = Number(btn.dataset.index);

            openModal(category, index);
        });

        modalBg?.addEventListener("click", closeModal);
        modalClose?.addEventListener("click", closeModal);
        modalPrev?.addEventListener("click", showPrev);
        modalNext?.addEventListener("click", showNext);

        document.addEventListener("keydown", (e) => {
            if (!modal.classList.contains("is-open")) return;

            if (e.key === "Escape") {
                closeModal();
            } else if (e.key === "ArrowLeft") {
                showPrev();
            } else if (e.key === "ArrowRight") {
                showNext();
            }
        });

        window.addEventListener("resize", () => {
            if (!modal.classList.contains("is-open")) return;
            updateModal();
        });
    }
}